import "./Loader.scss";
export function Loader({ label, color }: { label?: string; color?: string }) {
  return (
    <div class="loader">
      <div class="loader_spinner" style={{ "--color": color }}></div>
      {label && <div class="loader_label">{label}</div>}
    </div>
  );
}
